/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/axios';
 
 
interface Permissions {
    permissionAction: string;
    permissionUrl: string;
    permissionName: string;
    permissionId: string;
}
 
interface LoginUser {
    token: string,
    refreshToken: string,
    role: string
    username: string
    id: number,
    rbacPermissions: Permissions[]
}
interface FetchUserProfile {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber?: any,
    countryCode?: any,
    countryShortName?: any,
    profileImgUrl:any,
    id?: number
 
}
interface ConfirmLoginState{
    
    isLoading: boolean,
    isConfirmed: boolean,
    error: boolean,
    message: string | null,
}
 
interface LoginSlice {
 
    user: {
        isLoading: boolean;
       
        dataq: {
            data: LoginUser,
            status: boolean,
            message: string
        },
        error: boolean;
        message: string;
        role: string;
        username: string;
        emailSent: boolean;
        resetPassword: boolean;
        resetLink: string;
        forgotPasswordApi: boolean;
        emailError: string;
    }
    userProfile: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: {
            rows: FetchUserProfile[]
        },
        error: boolean;
    }
    confirmLogin:ConfirmLoginState;
 
}
 
const initialState: LoginSlice = {
    user: {
        isLoading: false,
        dataq: {
            data: null,
            status: false,
            message: ''
        },
        error: false,
        message: '',
        role: '',
        username: '',
        emailSent: false,
        resetPassword: false,
        resetLink: '',
        forgotPasswordApi: false,
        emailError: "",
    },
    userProfile: {
        isloading: false,
        status: false,
        message: '',
        data: {
            rows: null
        },
        error: false
    },
    confirmLogin: {
       
        isLoading: false,
    isConfirmed: false,
    error: false,
    message: null,
    }
};
 
 
 
const slice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginStart: (state, action) => {
            state.user = {
                ...state.user,
                isLoading: false,
                dataq: action.payload,
                error: false,
                message: ''
                
            };
        },
        updateUserObj: (state, action) => {
            state.user.dataq.data = {
                ...state.user.dataq.data,
                username: action.payload,
            };
        },
        updateUserObjRst: (state) => {
            state.user.dataq.data = {
                ...state.user.dataq.data,
                username: null,
            };
        },
        resetEmailStart: (state, action) => {
            state.user = {
                ...state.user,
                emailSent: action.payload,
                forgotPasswordApi: false
            };
        },
        resetPasswordStart: (state, action) => {
            state.user = {
                ...state.user,
                resetPassword: action.payload,
            };
        },
        setResetLink: (state, action) => {
            state.user = {
                ...state.user,
                resetLink: action.payload,
                forgotPasswordApi: true
            };
        },
        logout: (state, action) => {
            state.user = {
                ...state.user,
                isLoading: false,
                dataq: action.payload,
                error: false,
                message: '',
            };
        },
        loginError: (state, action) => {
            state.user = {
                ...state.user,
                isLoading: false,
                dataq: {
                    data: null,
                    status: false,
                    message: ''
                },
                error: action.payload.error,
                message: action.payload.msg,
                role: ''
            };
        },
        setEmailError: (state, action) => {
            state.user = {
                ...state.user,
                emailError: action.payload,
                forgotPasswordApi: false
            };
        },
        profileInfo:(state,action)=>{
            state.userProfile={
                ...state.userProfile,
                status:true,
                message:action.payload.message,
                data:action.payload.data,
                error:false
            }
        },
        profileErrorInfo:(state,action)=>{
            state.userProfile={
                ...state.userProfile,
                error:true,
                data:action.payload                
            }
        },
        startConfirmation: (state) => {
            state.confirmLogin.isLoading = true;
            state.confirmLogin.isConfirmed = false;
            state.confirmLogin.error = null;
          },
          confirmationSuccess: (state, action) => {
            state.confirmLogin.isLoading = false;
            state.confirmLogin.isConfirmed = true;
            state.confirmLogin.message = action.payload;
          },
          confirmationFailure: (state, action) => {
            state.confirmLogin.isLoading = false;
            state.confirmLogin.isConfirmed = false;
            state.confirmLogin.error = action.payload || 'This link is expired and it is valid for 30 minutes after receiving the email';
          },
    },
});
 
 
// Async action for login
export const loginAsync = (data: any) => async (dispatch: any) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/login`, data);        if (response.status === 200 || response.status === 201) {
            if (response.data.status) {
                if(response.data?.data?.role === ("MOBILE_USER")){
                    dispatch(slice.actions.loginError({msg: "Mobile users are not allowed to Admin Portal",error: true}));
                } else {
                localStorage.setItem("userObj", JSON.stringify(response.data))
                localStorage.setItem("token", response.data.data.token)
                localStorage.setItem("refreshToken", response.data.data.refreshToken)
                dispatch(slice.actions.loginStart(response.data));
                }
            }
        } else {
            dispatch(slice.actions.loginError({ msg: "Incorrect Credientials", error: true }));
            setTimeout(() => {
                dispatch(slice.actions.loginError({ msg: "", error: false }));
            }, 3000)
        }
        } catch (error: any) {
  const message = error?.response?.data?.message || error?.message; 
  dispatch(slice.actions.loginError({ msg: message, error: true }));
}
}
 
//ForgetPassword
export const forgotPassword = (data: any) => async (dispatch: any) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/forgotPassword`, { email: data });
        if (response.status === 200 || response.status === 201) {
            if (response.data.status) {
                localStorage.setItem("resetLink", response.data.data.resetLink)
                dispatch(slice.actions.resetEmailStart(true));
                dispatch(slice.actions.setResetLink(response.data.data.resetLink));
                setTimeout(() => {
                    dispatch(slice.actions.resetEmailStart(false));
                }, 5000)
            }
        } else {
            alert("Incorrect Email")
        }
    } catch (error) {
        if (error.message == "Request failed with status code 404") {
            dispatch(slice.actions.setEmailError("User/Email not found"))
        } else {
            dispatch(slice.actions.setEmailError(error.message))
        }
        setTimeout(() => {
            dispatch(slice.actions.setEmailError(""))
        }, 5000)
    }
};
 
//ResetPassword
export const resetpassword = (data: any, callback: any, callback2: any) => async (dispatch: any) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/resetpassword`, data);
        if (response.status === 200 || response.status === 201) {
            callback(response);
        } else {
            callback2();
        }
    } catch (error: any) {
        if (error.response?.data?.message === "jwt expired") {
            localStorage.removeItem("yourTokenKey");
            callback2("Session expired. Please log in again.");
        } else {
            callback2("Something went wrong. Please try again.");
        }
    }
};

//ChangePassword
export const changePassword = (data: any, callback: any, callback2: any) => async (dispatch: any) => {
   
        const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/changePassword`, data);
        if (response.status === 200 || response.status === 201) {
            callback()
        } else {
            callback2()
        }  
};
 
//Update Profile
export const updateProfile = (id:any,data: any) => async (dispatch: any) => {
    try{
        const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/updateProfile/${id}`, data);
        dispatch(slice.actions.profileInfo(response.data));
    }
    catch(err){
        dispatch(slice.actions.profileErrorInfo(err))
    } 
};

export const confirmLogin = (token: string) => async (dispatch: any) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/confirm-login/${token}`);
      dispatch(slice.actions.confirmationSuccess(response.data.message));
    } catch (error: any) {       
      dispatch(slice.actions.confirmationFailure(error.response?.data?.message ));     
    }
};
export const clearLoginUserReset = () => async (dispatch: any) => {
    dispatch(slice.actions.updateUserObjRst());
};
 
export const {startConfirmation,confirmationSuccess,confirmationFailure} = slice.actions;
export const reducer = slice.reducer;
export default slice;
